
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/news-letter",
      function () {
        return require("private-next-pages/news-letter/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/news-letter"])
      });
    }
  